import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CommAutoEmailThread = Loadable(
  lazy(() =>
    import("./CommAutoEmailThread").then(({ CommAutoEmailThread }) => ({
      default: CommAutoEmailThread,
    }))
  )
);

export const CommAutoEmailThreadRoutes = [
  {
    path: "/comm-automobile-policy/:customerId/email-thread/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoEmailThread />
      </AuthorizedRoute>
    ),
  },
];
